/* eslint-disable complexity */
import {IntlShape} from 'react-intl';

// 暂时没有处理国际化
export function dateFormat(paramTime: string | number | Date, intl: IntlShape): string {
    if (typeof paramTime === 'string' && !paramTime.includes('T')) {
        // safari不支持yyyy-MM-dd HH:mm:ss所以转换为yyyy/MM/dd HH:mm:ss（yyyy-MM-ddTHH:mm:ss.000Z除外）
        paramTime = paramTime.replace(/-/g, '/');
    }
    const paramTimeDate = new Date(paramTime);
    const paramMonth = paramTimeDate.getMonth() + 1 < 10
        ? `0${paramTimeDate.getMonth() + 1}` : paramTimeDate.getMonth() + 1;
    const paramDate = paramTimeDate.getDate() < 10 ? `0${paramTimeDate.getDate()}` : paramTimeDate.getDate();
    const paramHours = paramTimeDate.getHours() < 10 ? `0${paramTimeDate.getHours()}` : paramTimeDate.getHours();
    const paramMinutes = paramTimeDate.getMinutes() < 10
        ? `0${paramTimeDate.getMinutes()}` : paramTimeDate.getMinutes();
    const paramTimestamp = new Date(paramTime).getTime();
    const todayTimestamp = new Date(new Date().toDateString()).getTime(); // 今天整点时间戳
    // 传递的时间戳大于今天整点时间戳
    if (paramTimestamp - todayTimestamp > 0) {
        return `${paramHours}:${paramMinutes}`;
    }
    const yesterdayTimestamp = new Date(todayTimestamp).setDate(new Date(todayTimestamp).getDate() - 1);
    // 传递的时间戳 - 昨天整点时间戳 在一天内
    if (paramTimestamp - yesterdayTimestamp > 0) {
        return `${intl.formatMessage({id: 'textYesterday'})} ${paramHours}:${paramMinutes}`;
    }
    // 传递的时间戳 - 昨天整点时间戳 在2天内
    const beforeYesterdayTimestamp = new Date(todayTimestamp).setDate(new Date(todayTimestamp).getDate() - 2);
    if (paramTimestamp - beforeYesterdayTimestamp > 0) {
        return `${intl.formatMessage({id: 'textBeforeYesterday'})} ${paramHours}:${paramMinutes}`;
    }
    // 传递的时间戳 和 昨天整点时间戳 在同一年份
    if (paramTimeDate.getFullYear() === new Date().getFullYear()) {
        return `${paramMonth}-${paramDate} ${paramHours}:${paramMinutes}`;
    } else {
        return `${paramTimeDate.getFullYear()}-${paramMonth}-${paramDate}`;
    }
}

export function getMonthAndDay(time: number): string {
    if (!time) {
        return '';
    }
    const data = new Date(time); // 获取当前时间
    const month = data.getMonth() + 1; // 获取月（是从0到11，所以我们要给他加1）
    const fillMonth = month < 10 ? `0${month}` : month;
    const day = data.getDate(); // 获取日
    const fillDay = day < 10 ? `0${day}` : day;
    return `${fillMonth}-${fillDay}`;
}

export function isSameDay(time1: string | number | Date, time2: string | number | Date) {
    const paramTime1 = new Date(time1);
    const paramTime2 = new Date(time2);
    if (paramTime1.getFullYear() === paramTime2.getFullYear()
        && paramTime1.getMonth() === paramTime2.getMonth()
        && paramTime1.getDate() === paramTime2.getDate()) {
        return true;
    }
    return false;
}

export function distanceFromNow(time: number | string | Date) {
    if (time === 0) {
        return 0;
    }
    const date = new Date(time).getTime();
    const dateNow = Date.now();
    const distance = date - dateNow + 12 * 60 * 60 * 1000;
    return Math.floor(distance / (24 * 60 * 60 * 1000));
}

// 新的时间展示规则跟移动端的时间展示规则是一样的
export function timeFormat(paramTime: string | number | Date, intl: IntlShape): string {
    if (!paramTime) {
        return '';
    }
    const paramTimeDate = new Date(paramTime);
    const paramMonth = paramTimeDate.getMonth() + 1 < 10
        ? `0${paramTimeDate.getMonth() + 1}` : paramTimeDate.getMonth() + 1;
    const paramDate = paramTimeDate.getDate() < 10 ? `0${paramTimeDate.getDate()}` : paramTimeDate.getDate();
    const paramHours = paramTimeDate.getHours() < 10 ? `0${paramTimeDate.getHours()}` : paramTimeDate.getHours();
    const paramMinutes = paramTimeDate.getMinutes() < 10
        ? `0${paramTimeDate.getMinutes()}` : paramTimeDate.getMinutes();

    const paramTimestamp = new Date(paramTime).getTime();
    const todayTimestamp = new Date(new Date().toDateString()).getTime(); // 今天整点时间戳
    const nowTimestamp = new Date().getTime(); // 当前时间的时间戳

    // 一分钟以内
    if (nowTimestamp - paramTimestamp <= 60 * 1000) {
        return '刚刚';
    }

    const minutesTimetamp = Math.round((nowTimestamp - paramTimestamp) / 1000 / 60);
    // 一小时以内
    if (nowTimestamp - paramTimestamp < 60 * 60 * 1000) {
        return `${minutesTimetamp}${intl.formatMessage({id: 'mobileTimeMinuteBefore'})}`;
    }

    const hoursTimetamp = Math.round((nowTimestamp - paramTimestamp) / 1000 / 60 / 60);
    // 三小时以内
    if (nowTimestamp - paramTimestamp <= 3 * 60 * 60 * 1000) {
        return `${hoursTimetamp}${intl.formatMessage({id: 'mobileTimeHoursBefore'})}`;
    }

    // 传递的时间戳大于今天整点时间戳
    if (paramTimestamp - todayTimestamp > 0) {
        return `${paramHours}:${paramMinutes}`;
    }

    // 传递的时间戳 和 昨天整点时间戳 在同一年份
    if (paramTimeDate.getFullYear() === new Date().getFullYear()) {
        return `${paramMonth}-${paramDate} ${paramHours}:${paramMinutes}`;
    } else {
        return `${paramTimeDate.getFullYear()}-${paramMonth}-${paramDate}`;
    }
}

// 时间差
export function getDateDiffRecommendReading(dateTimeStamp: number) {
    let result = '';
    const minute = 1000 * 60;
    const hour = minute * 60;
    const day = hour * 24;
    const month = day * 30;
    const year = month * 12;
    const now = new Date().getTime();
    const diffValue = now - dateTimeStamp;
    if (diffValue < 0) {
        return '';
    }
    const yearC = diffValue / year;
    const monthC = diffValue / month;
    const weekC = diffValue / (7 * day);
    const dayC = diffValue / day;
    // const hourC = diffValue / hour;
    // const minC = diffValue / minute;

    if (yearC >= 1) {
        result = `${Math.floor(yearC)}年前`;
    }
    else if (monthC >= 1) {
        result = `${Math.floor(monthC)}月前`;
    }
    else if (weekC >= 1) {
        result = `${Math.floor(weekC)}周前`;
    }
    else if (dayC >= 1) {
        result = `${Math.floor(dayC)}天前`;
    } else {
        result = '今天';
    }
    return result;
}
export const formatDateForTimestamp = (time: number, format = 'YY-MM-DD hh:mm:ss') => {
    const date = new Date(time);
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // 月份是从0开始的
    const day = date.getDate();
    const hour = date.getHours();
    const min = date.getMinutes();
    const sec = date.getSeconds();
    const preArr = Array(10).fill(null).map((i, index) => `0${index}`);

    const newTime = format
        .replace(/YY/g, `${year}`)
        .replace(/MM/g, preArr[month] || `${month}`)
        .replace(/DD/g, preArr[day] || `${day}`)
        .replace(/hh/g, preArr[hour] || `${hour}`)
        .replace(/mm/g, preArr[min] || `${min}`)
        .replace(/ss/g, preArr[sec] || `${sec}`);
    return newTime;
};

// 仅限头部时间部分 日期小于10 不加0
export function dateFormatDelZero(paramTime: string | number | Date, intl: IntlShape): string {
    if (typeof paramTime === 'string' && !paramTime.includes('T')) {
        // safari不支持yyyy-MM-dd HH:mm:ss所以转换为yyyy/MM/dd HH:mm:ss（yyyy-MM-ddTHH:mm:ss.000Z除外）
        paramTime = paramTime.replace(/-/g, '/');
    }
    const paramTimeDate = new Date(paramTime);
    const paramMonth = paramTimeDate.getMonth() + 1;
    const paramDate = paramTimeDate.getDate();
    const paramHours = paramTimeDate.getHours() < 10 ? `0${paramTimeDate.getHours()}` : paramTimeDate.getHours();
    const paramMinutes = paramTimeDate.getMinutes() < 10
        ? `0${paramTimeDate.getMinutes()}` : paramTimeDate.getMinutes();
    const paramTimestamp = new Date(paramTime).getTime();
    const todayTimestamp = new Date(new Date().toDateString()).getTime(); // 今天整点时间戳
    // 传递的时间戳大于今天整点时间戳
    if (paramTimestamp - todayTimestamp > 0) {
        return `${paramHours}:${paramMinutes}`;
    }
    const yesterdayTimestamp = new Date(todayTimestamp).setDate(new Date(todayTimestamp).getDate() - 1);
    // 传递的时间戳 - 昨天整点时间戳 在一天内
    if (paramTimestamp - yesterdayTimestamp > 0) {
        return `${intl.formatMessage({id: 'textYesterday'})} ${paramHours}:${paramMinutes}`;
    }
    // 传递的时间戳 - 昨天整点时间戳 在2天内
    const beforeYesterdayTimestamp = new Date(todayTimestamp).setDate(new Date(todayTimestamp).getDate() - 2);
    if (paramTimestamp - beforeYesterdayTimestamp > 0) {
        return `${intl.formatMessage({id: 'textBeforeYesterday'})} ${paramHours}:${paramMinutes}`;
    }
    // 传递的时间戳 和 昨天整点时间戳 在同一年份
    if (paramTimeDate.getFullYear() === new Date().getFullYear()) {
        return `${paramMonth}-${paramDate} ${paramHours}:${paramMinutes}`;
    } else {
        return `${paramTimeDate.getFullYear()}-${paramMonth}-${paramDate}`;
    }
}

// 暂时没有处理国际化
export function dateFormatBrowseRecords(paramTime: string | number | Date, intl: IntlShape): string {
    if (typeof paramTime === 'string' && !paramTime.includes('T')) {
        // safari不支持yyyy-MM-dd HH:mm:ss所以转换为yyyy/MM/dd HH:mm:ss（yyyy-MM-ddTHH:mm:ss.000Z除外）
        paramTime = paramTime.replace(/-/g, '/');
    }
    const paramTimeDate = new Date(paramTime);
    const paramMonth = paramTimeDate.getMonth() + 1 < 10
        ? `0${paramTimeDate.getMonth() + 1}` : paramTimeDate.getMonth() + 1;
    const paramDate = paramTimeDate.getDate() < 10 ? `0${paramTimeDate.getDate()}` : paramTimeDate.getDate();
    const paramTimestamp = new Date(paramTime).getTime();
    const todayTimestamp = new Date(new Date().toDateString()).getTime(); // 今天整点时间戳
    // 传递的时间戳大于今天整点时间戳
    if (paramTimestamp - todayTimestamp > 0) {
        return `${intl.formatMessage({id: 'textToday'})}`;
    }
    const yesterdayTimestamp = new Date(todayTimestamp).setDate(new Date(todayTimestamp).getDate() - 1);
    // 传递的时间戳 - 昨天整点时间戳 在一天内
    if (paramTimestamp - yesterdayTimestamp > 0) {
        return `${intl.formatMessage({id: 'textYesterday'})}`;
    }
    // 传递的时间戳 和 昨天整点时间戳 在同一年份
    if (paramTimeDate.getFullYear() === new Date().getFullYear()) {
        return `${paramMonth}-${paramDate}`;
    } else {
        return `${paramTimeDate.getFullYear()}-${paramMonth}-${paramDate}`;
    }
}

export function dateFormatToDay(paramTime: string | number | Date, intl: IntlShape): string {
    if (typeof paramTime === 'string' && !paramTime.includes('T')) {
        // safari不支持yyyy-MM-dd HH:mm:ss所以转换为yyyy/MM/dd HH:mm:ss（yyyy-MM-ddTHH:mm:ss.000Z除外）
        paramTime = paramTime.replace(/-/g, '/');
    }
    const paramTimeDate = new Date(paramTime);
    const paramMonth = paramTimeDate.getMonth() + 1;
    const paramDate = paramTimeDate.getDate();
    const paramTimestamp = new Date(paramTime).getTime();
    const todayTimestamp = new Date(new Date().toDateString()).getTime(); // 今天整点时间戳
    // 传递的时间戳大于今天整点时间戳
    if (paramTimestamp - todayTimestamp > 0) {
        return `${intl.formatMessage({id: 'textToday'})}`;
    }
    const yesterdayTimestamp = new Date(todayTimestamp).setDate(new Date(todayTimestamp).getDate() - 1);
    // 传递的时间戳 - 昨天整点时间戳 在一天内
    if (paramTimestamp - yesterdayTimestamp > 0) {
        return `${intl.formatMessage({id: 'textYesterday'})}`;
    }
    // 传递的时间戳 - 昨天整点时间戳 在2天内
    const beforeYesterdayTimestamp = new Date(todayTimestamp).setDate(new Date(todayTimestamp).getDate() - 2);
    if (paramTimestamp - beforeYesterdayTimestamp > 0) {
        return `${intl.formatMessage({id: 'textBeforeYesterday'})}`;
    }
    // 传递的时间戳 和 昨天整点时间戳 在同一年份
    if (paramTimeDate.getFullYear() === new Date().getFullYear()) {
        return `${paramMonth}-${paramDate}`;
    } else {
        return `${paramTimeDate.getFullYear()}-${paramMonth}-${paramDate}`;
    }
}

export function convertTimestampToFormattedDate(time: number) {
    if (!time) {
        return '';
    }
    const timeDate = new Date(time);
    const year = timeDate.getFullYear();
    const month = timeDate.getMonth() + 1 < 10
        ? `0${timeDate.getMonth() + 1}` : timeDate.getMonth() + 1;
    const date = timeDate.getDate() < 10 ? `0${timeDate.getDate()}` : timeDate.getDate();
    const Hours = timeDate.getHours() < 10 ? `0${timeDate.getHours()}` : timeDate.getHours();
    const Minutes = timeDate.getMinutes() < 10
        ? `0${timeDate.getMinutes()}` : timeDate.getMinutes();
    // 传递的时间戳 和 昨天整点时间戳 在同一年份
    if (year === new Date().getFullYear()) {
        return `${month}-${date} ${Hours}:${Minutes}`;
    } else {
        return `${year}-${month}-${date} ${Hours}:${Minutes}`;
    }
}

export function dateFormatTime(paramTime: string | number | Date, intl: IntlShape): string {
    if (typeof paramTime === 'string' && !paramTime.includes('T')) {
        // safari不支持yyyy-MM-dd HH:mm:ss所以转换为yyyy/MM/dd HH:mm:ss（yyyy-MM-ddTHH:mm:ss.000Z除外）
        paramTime = paramTime.replace(/-/g, '/');
    }
    const paramTimeDate = new Date(paramTime);
    const paramMonth = paramTimeDate.getMonth() + 1 < 10
        ? `0${paramTimeDate.getMonth() + 1}` : paramTimeDate.getMonth() + 1;
    const paramDate = paramTimeDate.getDate() < 10 ? `0${paramTimeDate.getDate()}` : paramTimeDate.getDate();
    const paramHours = paramTimeDate.getHours() < 10 ? `0${paramTimeDate.getHours()}` : paramTimeDate.getHours();
    const paramMinutes = paramTimeDate.getMinutes() < 10
        ? `0${paramTimeDate.getMinutes()}` : paramTimeDate.getMinutes();
    const paramTimestamp = new Date(paramTime).getTime();
    const todayTimestamp = new Date(new Date().toDateString()).getTime(); // 今天整点时间戳
    // 传递的时间戳大于今天整点时间戳
    if (paramTimestamp - todayTimestamp > 0) {
        return `${intl.formatMessage({id: 'textToday'})} ${paramHours}:${paramMinutes}`;
    }
    const yesterdayTimestamp = new Date(todayTimestamp).setDate(new Date(todayTimestamp).getDate() - 1);
    // 传递的时间戳 - 昨天整点时间戳 在一天内
    if (paramTimestamp - yesterdayTimestamp > 0) {
        return `${intl.formatMessage({id: 'textYesterday'})} ${paramHours}:${paramMinutes}`;
    }
    // 传递的时间戳 - 昨天整点时间戳 在2天内
    const beforeYesterdayTimestamp = new Date(todayTimestamp).setDate(new Date(todayTimestamp).getDate() - 2);
    if (paramTimestamp - beforeYesterdayTimestamp > 0) {
        return `${intl.formatMessage({id: 'textBeforeYesterday'})} ${paramHours}:${paramMinutes}`;
    }
    // 传递的时间戳 和 昨天整点时间戳 在同一年份
    if (paramTimeDate.getFullYear() === new Date().getFullYear()) {
        return `${paramMonth}-${paramDate} ${paramHours}:${paramMinutes}`;
    } else {
        return `${paramTimeDate.getFullYear()}-${paramMonth}-${paramDate}`;
    }
}
